module.exports = __webpack_public_path__ + "static/media/pattaptap.3ed4af9e.png";